import { useCallback } from 'react';
import { UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';
import { useEffect } from 'react';

export const useImageUrlResetter = (
  watch: UseFormWatch<EditableQuestion>,
  setValue: UseFormSetValue<EditableQuestion>
) => {
  const uploadedImageFile = watch('image');
  const imageUrl = watch('image_url');

  const isImageUploadedOrRemoved = uploadedImageFile === null || uploadedImageFile;

  const resetImageUrl = useCallback(() => {
    setValue('image_url', null);
  }, [setValue]);

  useEffect(() => {
    if (isImageUploadedOrRemoved) {
      resetImageUrl();
    }
  }, [isImageUploadedOrRemoved, resetImageUrl]);

  return { imageUrl };
};
